import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export enum UmpireIncidentSectionTypeEnum {
  GOAL = 'goal',
  ASSIST = 'assist',
  MATCH_STATUS = 'match_status',
  SUBSTITUTION = 'substitution',
  OTHER_INCIDENT = 'other_incident',
}

export type IncidentSectionTypeWithComponentType =
  | UmpireIncidentSectionTypeEnum
  | Extract<
      UmpireComponentTypeEnum,
      | UmpireComponentTypeEnum.SOCIAL_MEDIA
      | UmpireComponentTypeEnum.ADVERTISEMENT
      | UmpireComponentTypeEnum.TEXT
      | UmpireComponentTypeEnum.IMAGE
      | UmpireComponentTypeEnum.QUIZ
      | UmpireComponentTypeEnum.SURVEY
      | UmpireComponentTypeEnum.VIDEO
      | UmpireComponentTypeEnum.IFRAME
    >;
